/**
 * Packaging OS — access-mode label resolver (Phase 1R-A-Fix-6).
 *
 * Maps the raw `access_mode` string that Core returns from /api/whoami
 * to a localized human-readable label. Falls back to the controlled
 * "unknown" label so RTL UIs never display a raw `super_admin` /
 * `preview` token directly to end-users.
 */

import type { UiStrings } from "./strings";

export function accessModeLabel(t: UiStrings, mode: string | null | undefined): string {
  const code = (mode ?? "").trim().toLowerCase();
  switch (code) {
    case "super_admin":
    case "superadmin":
      return t.accessModeSuperAdmin;
    case "admin":
      return t.accessModeAdmin;
    case "operator":
      return t.accessModeOperator;
    case "user":
      return t.accessModeUser;
    case "preview":
      return t.accessModePreview;
    case "":
      return "—";
    default:
      return t.accessModeUnknown;
  }
}
